import { Observable } from 'rxjs';
import { Allocation, Interviewer } from '../../interfaces/allocation/allocation.interface';
import { BaseService } from '../../../../core/services/base.service';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';
import { AllocationSearchParam } from '../..//interfaces/allocation/allocation-search-param.interface';

export interface AllocateInterviewRequest {
    ccmUniqueId: string;
    interviewerUniqueId: string;
    date: string;
    startTime: string;
    endTime: string;
}

export abstract class AllocationService extends BaseService<Allocation> {
    abstract override findAll(params: AllocationSearchParam): Observable<PageResponse<Allocation>>;
    abstract getInterviewers(id?: string): Observable<Interviewer[]>;
    abstract allocate(assessmentUniqueId: string, payload: AllocateInterviewRequest[]): Observable<void>;
    abstract approve(data: {
        bookingUniqueId: string;
        interviewerUniqueId: string;
        fromTime: string;
        toTime: string;
        date: string;
    }): Observable<void>;
}
